import { STOCK_APPROVAL_PHASE } from "@erp/shared/types/stock-approval-phase.types";
import { INBOUND_TYPE } from "@erp/shared/types/inbound-type.types";
export const searchCardInputs = [
    {
        label: "승인",
        key: "approvalPhase",
        type: "auto",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        list: [
            STOCK_APPROVAL_PHASE.미확인,
            STOCK_APPROVAL_PHASE.미승인,
            STOCK_APPROVAL_PHASE.승인,
            STOCK_APPROVAL_PHASE.반려,
        ],
        clearable: true,
    },
    {
        label: "프로젝트",
        key: "projectCode",
        type: "auto",
        list: [],
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "입고방식",
        key: "addData",
        type: "auto",
        col: "12",
        sm: "2",
        lg: "2",
        value: "",
        list: [
            INBOUND_TYPE.발주내역,
            INBOUND_TYPE.직접입력,
            INBOUND_TYPE.자재선택,
            INBOUND_TYPE.출고내역,
        ],
        clearable: true,
    },
    {
        label: "입고일자",
        key: "inboundDate",
        type: "dateRange",
        value: [],
        col: "12",
        sm: "2",
        lg: "2",
    },
];
export const inboundApproveHeaders = [
    { text: "No.", align: "center", value: "id" },
    { text: "승인 단계", align: "center", value: "approvalPhase" },
    { text: "작성일", align: "center", value: "createdTime" },
    { text: "요청자", align: "center", value: "createrName" },
    { text: "확인자", align: "center", value: "checkerName" },
    { text: "승인자", align: "center", value: "approverName" },
    { text: "구매담당자", align: "center", value: "purchaseManagerName" },
    { text: "자재담당자", align: "center", value: "materialManagerName" },
    { text: "프로젝트", align: "center", value: "projectCode" },
    { text: "입고요청일", align: "center", value: "inboundDate" },
    { text: "입고방식", align: "center", value: "addData" },
];
export const inboundProductHeaders = [
    { text: "종류", align: "center", value: "type" },
    { text: "분류", align: "center", value: "classification" },
    { text: "관리코드", align: "center", value: "productCode" },
    { text: "제품명", align: "center", value: "name" },
    { text: "모델명", align: "center", value: "model" },
    { text: "사양", align: "center", value: "spec" },
    { text: "입고위치", align: "center", value: "spot" },
    { text: "입고수량", align: "center", value: "num" },
    { text: "입고금액", align: "center", value: "unitPrice" },
];
